import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../Context/UserContext';
import { hasPermission } from '../Utils/permissions';

/**
 * Guards a page/section by permission.
 *
 * Props:
 * - permission: string (required unless anyOf is provided)
 * - anyOf: string[] (optional) -> allow if any permission is true
 * - fallbackTo: string (optional) -> where to redirect if not allowed
 */
export default function RequirePermission({ children, permission, anyOf, fallbackTo = '/admin' }) {
  const { user, loading, permissions } = useUser();

  if (loading) {
    return <div className="loading-screen"><div className="spinner"></div></div>;
  }

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  const allow = Array.isArray(anyOf) && anyOf.length > 0
    ? anyOf.some((p) => hasPermission(permissions, p))
    : hasPermission(permissions, permission);

  if (!allow) {
    return <Navigate to={fallbackTo} replace />;
  }

  return children;
}
